import * as React from "react";
import { observer } from "mobx-react-lite";
import { classNames } from "src/common/classNames";
import { Button, Checkbox, Dropdown, MenuProps, Slider } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import {
  Planning2GanttStore,
  ScaleMode,
  scaleModes,
} from "./Planning2GanttStore";
import styles from "./Planning2Gantt.module.less";

type PropsPl2GanttTools = {
  gantt: Planning2GanttStore;
};

export const Pl2GanttTools: React.FC<PropsPl2GanttTools> = observer(
  ({ gantt }) => {
    const items: MenuProps["items"] = Object.entries(scaleModes).map(
      ([key, label]) => ({
        key,
        label,
        icon: <Checkbox checked={key === gantt.scaleMode} />,
      }),
    );
    return (
      <div className={styles.ganttToolBox}>
        <div className={styles.ganttTools}>
          <Bar cls={styles.prognosisBar}>Прогноз</Bar>
          <Bar cls={styles.workBar}>В&nbsp;работе</Bar>
          <Bar cls={styles.factBar}>Факт</Bar>
          <Bar cls={styles.planBar}>План</Bar>
          <Bar cls={styles.delayBar}>Задержка</Bar>
          <div style={{ flex: 1 }} />
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => gantt.setScaleMode(key as ScaleMode),
            }}
          >
            <span>Масштаб:</span>
          </Dropdown>
          <div className={styles.scaleBox}>
            <Slider
              tooltip={{ open: false }}
              value={gantt.worldScale}
              onChange={(newValue) => gantt.changeWorldScale(newValue)}
            />
          </div>
          <span>Привязки:</span>
          <div>
            <Button
              size="small"
              icon={
                gantt.finalArrowVisible ? (
                  <EyeOutlined />
                ) : (
                  <EyeInvisibleOutlined />
                )
              }
              disabled={gantt.arrowsDisabled}
              onClick={() => gantt.changeArrowsVisible(!gantt.arrowsVisible)}
            />
          </div>
        </div>
      </div>
    );
  },
);

type PropsBar = {
  cls: string;
  children: React.ReactNode;
};
const Bar: React.FC<PropsBar> = ({ cls, children }) => (
  <div className={styles.legendItem}>
    <div className={classNames([styles.legendBar, cls])} />
    <span>{children}</span>
  </div>
);
